import { Table } from 'reactstrap'
import { enterKeyHandler, getTenant, getToken } from '../../../utils'
import useForm from '../../CustomHooks/FormHook'
import '../Custom.css'
import FormSubmitButton from '../FormSubmitButton'
import ReportHeading from '../ReportHeading'
import TextInput from '../TextInput'

export default function OpenClaimsByAttorneyPDF({ location }) {
  console.log('OpenClaimsByAttorneyPDF rendered: ', location)

  const init = {
    assignedAttorney: '',
    supervisingAttorney: ''
  }

  const { inputs, handleInputChange, handleSubmit } = useForm(init, submitSearch, enterKeyHandler(submitSearch))

  async function submitSearch() {
    console.log('OpenClaimsByAttorneyPDF.submitSearch', inputs)
    function tokenSuccess(jwt) {
      const link = document.createElement('a')
      document.body.appendChild(link)
      link.href = `${process.env.REACT_APP_SERVER}/pdf/${getTenant()}/custom/Bisc/openClaimsPDF/open_claims_by_attorney?inputs=${JSON.stringify(inputs)}&jwt=${jwt}`
      link.setAttribute('type', 'hidden')
      link.setAttribute('target', '_blank')
      link.click()
    }
    function tokenError(error) {
      console.log('PDFLink: ', JSON.stringify(error))
    }
    getToken(tokenSuccess, tokenError)
  }
  return (
    <div className="custom-scroll">
      <form className="form" onSubmit={handleSubmit}>
        <div>
          <Table bordered className="custom-table custom-form-table" style={{backgroundColor: 'white'}}>
            <ReportHeading title='Open Claims By Attorney Report' showReportDate={false} widths={['0%', '100%', '0%']} />
            <tbody>
              <TextInput label='Assigned Attorney' name='assignedAttorney' handleInputChange={handleInputChange} />
              <TextInput label='Supervising Attorney' name='supervisingAttorney' handleInputChange={handleInputChange} />
            </tbody>
          </Table>
        </div>
        <div style={{ textAlign: 'center', margin: '10px' }}>
          <FormSubmitButton />
        </div>
      </form>
    </div>
  )
}

